var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "messenger-channel-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: { paths: [{ title: "Messenger Channel Detail" }], select: true },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "IconButton",
                    {
                      attrs: {
                        "on-click": function () {
                          return _vm.$router.push("/integrations/messenger")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" chevron_left "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [_c("MessengerIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(
                      _vm._s(_vm.$t("messenger.channels")) +
                        " : " +
                        _vm._s(_vm.channel.name)
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("whatsappChannel.deleteChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "channel-content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("ChannelMenu", {
                    model: {
                      value: _vm.currentTab,
                      callback: function ($$v) {
                        _vm.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "page-content" }, [
                _vm.currentTab === _vm.MessengerMenuTypes.CHANNEL.id
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MessengerMenuTypes.VISIBILITY.id
                  ? _c(
                      "div",
                      [
                        _c("Visibility", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MessengerMenuTypes.COMMENT_SETTINGS.id
                  ? _c(
                      "div",
                      [
                        _c("MessengerCommentManagement", {
                          attrs: { value: _vm.channel },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MessengerMenuTypes.AD_OPTIMIZATION.id
                  ? _c(
                      "div",
                      [
                        _c("AdOptimization", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("messenger.channel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWMessengerChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("messenger.deleteDesc")))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }